/** El chip de segmento que no acota; el mismo rótulo en crédito y en venta. */
export const ALL_SEGMENTS_LABEL = 'Todos los segmentos';

/** El título y el «?» de la columna de cadena del alcance. */
export const RETAILER_SCOPE_TITLE = 'Cadena';
export const RETAILER_SCOPE_HELP =
    'Al crear puedes elegir varias cadenas: se guarda una copia por cadena, cada una con su presupuesto y su historial. Ya creada, la cadena no cambia.';
export const RETAILER_CREATED_LEGEND = 'Ya creada';
export const RETAILERS_LOADING_LABEL = 'Cargando cadenas…';
export const RETAILERS_EMPTY_LABEL = 'No hay cadenas para elegir.';
